import Grid from "@material-ui/core/Grid";
import Slider from "@material-ui/core/Slider";
import $ from "jquery";
import React, { useEffect, useState } from "react";
import S3 from "react-aws-s3";
import * as XLSX from "xlsx";

import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

import TextField from "@material-ui/core/TextField";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { Auth } from "aws-amplify";
import { useParams } from "react-router-dom";

import Snackbar from "@material-ui/core/Snackbar";

import { API } from "aws-amplify";
import {
  createEduvanceAITool,
  updateEduvanceAITool,
} from "../../graphql/mutations";
import { getEduvanceAITool } from "../../graphql/queries";

import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

const MultiConfigProject = (props) => {
  let { uname, pname } = useParams();

  const [uploadMode, setUploadMode] = useState("");
  const [uploadModeTesting, setUploadModeTesting] = useState("");
  const [value, setValue] = useState(80);
  const [epochs, setEpochs] = useState(5);
  const [filename, setFileName] = useState("No file uploaded");
  const [filenameTesting, setFileNameTesting] = useState("No file uploaded");
  const [columns, setColumns] = useState([]);
  const [ipColumns, setIpColumns] = useState([]);
  const [opColumns, setOpColumns] = useState([]);
  const [zipfile, setZipFile] = useState("");
  const [data, setData] = useState([]);
  const [fileData, setFileData] = useState("");
  const [fileDataTesting, setFileDataTesting] = useState("");
  const [modelSaved, setModelSaved] = useState(false);
  const [progressBar, setProgressBar] = useState(false);
  const [graphData, setGraphData] = useState([]);
  const [testingGraphData, setTestingGraphData] = useState([]);
  const [algoType, setAlgoType] = useState("");
  const [invalidProject, setInvalidProject] = useState(false);
  const [projectJson, setProjectJson] = useState({});
  const [mappingjson, setMappingJson] = useState({
    inputs: "",
    outputs: "",
    algorithm: "",
    testsize: "",
    epochs: "",
  });

  const headerValues = [
    "80:20 Split",
    "60:40 Split",
    "50:50 Split",
    "40:60 Split",
    "20:80 Split",
    "100% Dataset",
    "80% Dataset",
    "60% Dataset",
    "40% Dataset",
    "20% Dataset",
  ];

  var oldDate, newDate;

  useEffect(() => {
    document.getElementById("pname").value = pname;
    getGraphData();
  }, []);

  const handleprojectjsonchange = (e) => {
    setProjectJson(e);
  };
  async function getGraphData() {
    const apiData = await API.graphql({
      query: getEduvanceAITool,
      variables: { projectname: uname + "//Intermediate//" + pname },
    });
    try {
      var pjson = JSON.parse(apiData.data.getEduvanceAITool["projectData"]);

      if (pjson["datafile"]) {
        document.getElementById("outlined-basic").value = pjson[
          "datafile"
        ].startsWith("https://eduvancewebai.s3.ap-south-1.amazonaws.com")
          ? ""
          : pjson["datafile"];
        if (
          pjson["datafile"].startsWith(
            "https://eduvancewebai.s3.ap-south-1.amazonaws.com",
          )
        ) {
          // console.log("there " + pjson["datafile"]);
        } else {
          handleLinkUpload();
          console.log("here");
        }
      }
      if (pjson["testfile"]) {
        document.getElementById("outlined-basic-testing").value = pjson[
          "testfile"
        ].startsWith("https://eduvancewebai.s3.ap-south-1.amazonaws.com")
          ? ""
          : pjson["testfile"];
        if (
          pjson["datafile"].startsWith(
            "https://eduvancewebai.s3.ap-south-1.amazonaws.com",
          )
        ) {
          // console.log("there " + pjson["testfile"]);
        } else {
          handleLinkUploadTesting();
          console.log("here");
        }
      }
      document.getElementById("algorithmtype").value = pjson["algotype"];

      let filelink = `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")}/${document.getElementById("pname").value.trim()}_config.json`;
      fetch(filelink)
        .then((response) => response.json())
        .then((json) => {
          let variations = [10, 30, 60, 80, 100];
          let variations2 = [20, 40, 50, 60, 80];
          handleprojectjsonchange(json);
          console.log("project json " + projectJson["inputs"]);
          // console.log("json " + JSON.stringify(json));
          let algos = [];
          let finalarray = [];
          let testingarray = [];
          if (json["algotype"] === "regression") {
            setAlgoType("regression");
          } else {
            setAlgoType("classification");
          }
          for (var key in json["phase1"]) {
            algos.push(key);
          }

          let tempdict = {};
          let testingDict = {};
          for (var i = 1; i < 6; i++) {
            finalarray[i - 1] = [];
            testingarray[i - 1] = [];
            variations.forEach((e) => {
              // console.log("ee "+e);
              tempdict["name"] = e;
              testingDict["name"] = e;
              algos.forEach((a) => {
                tempdict[a] = json["phase1"][a][`g${i}-` + e];
                testingDict[a] = json["testingpahse1"][a][`g${i}-` + e];
              });
              finalarray[i - 1].push(tempdict);
              testingarray[i - 1].push(testingDict);
              tempdict = {};
              testingDict = {};
            });
          }

          setGraphData(finalarray);
          setTestingGraphData(testingarray);
        });
    } catch (e) {
      console.log("invalid projecy" + e);
      setInvalidProject(true);
    }
  }

  const handleModelSavedClose = () => {
    setModelSaved(false);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleepochchange = (event, newValue) => {
    setEpochs(newValue);
  };

  const processData = (dataString) => {
    const dataStringLines = dataString.split(/\r\n|\n/);
    const headers = dataStringLines[0].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/,
    );

    const list = [];
    for (let i = 1; i < dataStringLines.length; i++) {
      const row = dataStringLines[i].split(
        /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/,
      );
      if (headers && row.length == headers.length) {
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          let d = row[j];
          if (d.length > 0) {
            if (d[0] == '"') d = d.substring(1, d.length - 1);
            if (d[d.length - 1] == '"') d = d.substring(d.length - 2, 1);
          }
          if (headers[j]) {
            obj[headers[j]] = d;
          }
        }

        // remove the blank rows
        if (Object.values(obj).filter((x) => x).length > 0) {
          list.push(obj);
        }
      }
    }

    // prepare columns list from headers
    const columns = headers.map((c) => ({
      name: c,
      selector: c,
    }));

    setData(list);
    setColumns(columns);
    // columns.forEach(e => {
    //     console.log('e '+JSON.stringify(e));
    // })
    // console.log("cols "+columns);
  };

  const handleLinkUpload = (element) => {
    setColumns([]);
    setZipFile("");
    setFileName("No file uploaded");
    setUploadMode("link");
    // document.getElementById('contained-button-file').value = "";

    // let e = element;
    // const fileName = e.target.value.split('\\');

    // setFileName(fileName[fileName.length-1]);
    let tempfile = document.getElementById("outlined-basic").value;
    // console.log("here is link " + tempfile);

    if (tempfile.includes(".csv")) {
      fetch(tempfile)
        .then((response) => response.text())
        .then((response) => {
          let textdata = response;
          setFileData(textdata);

          // console.log("here id bstr " + textdata);
          const wb = XLSX.read(textdata, { type: "binary" });
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          /* Convert array of arrays */
          const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });
          processData(data);
        });
    } else if (tempfile.includes(".zip")) {
      setZipFile(tempfile);
    }
  };

  const handleLinkUploadTesting = (element) => {
    setFileNameTesting("No file uploaded");
    setUploadModeTesting("link");
    // document.getElementById('contained-button-file-testing').value = "";

    let tempfile = document.getElementById("outlined-basic-testing").value;
  };

  function getConfigDate(url, wch) {
    try {
      var req = new XMLHttpRequest();
      req.open("GET", url, false);
      req.setRequestHeader("Cache-Control", "no-cache");
      req.send(null);
      if (req.status == 200) {
        return new Date(req.getResponseHeader(wch));
      } else return false;
    } catch (er) {
      return er.message;
    }
  }

  const getConfigJson = () => {
    fetch(
      `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")}/${document.getElementById("pname").value.trim()}_config.json`,
    )
      .then((response) => response.json())
      .then((json) => {});
  };

  const trainModel = async () => {
    setGraphData([]);
    setTestingGraphData([]);
    var mapping = {};
    setProgressBar(true);
    mapping["username"] = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    mapping["project"] = document.getElementById("pname").value;
    if (uploadMode === "link") {
      mapping["datafile"] = document.getElementById("outlined-basic").value;
    } else {
      mapping["datafile"] =
        `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${mapping["username"]}/sample.csv`;
    }
    if (uploadModeTesting === "link") {
      mapping["testfile"] = document.getElementById(
        "outlined-basic-testing",
      ).value;
    } else {
      mapping["testfile"] =
        `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${mapping["username"]}/sampleTest.csv`;
    }
    mapping["algorithm"] = "MultiBuild";
    mapping["inputs"] = [];
    mapping["outputs"] = [];
    mapping["algotype"] = document.getElementById("algorithmtype").value;

    if (localStorage.getItem("validity") === "free") {
      mapping["validity"] = "free";
    } else {
      mapping["validity"] = "premium";
    }
    setMappingJson(mapping);
    let temp = document.querySelectorAll('[id^="ip"]');
    temp.forEach((e) => {
      // console.log(e.value);
      if (document.getElementById(`ip${e.value}`).checked) {
        mapping["inputs"].push(e.value);
      }
    });
    temp = document.querySelectorAll('[id^="op"]');
    temp.forEach((e) => {
      // console.log(e.value);
      if (document.getElementById(`op${e.value}`).checked) {
        mapping["outputs"].push(e.value);
      }
    });

    try {
      // Upload training dataset
      if (uploadMode !== "link") {
        await deleteUserFolder(mapping.username);
        await uploadFileViaPresignedUrl(fileData, mapping.username);
      }

      // Upload testing dataset
      if (uploadModeTesting !== "link") {
        await uploadFileViaPresignedUrl(fileDataTesting, mapping.username);
      }
    } catch (err) {
      console.error("Upload failed:", err);
      setProgressBar(false);
      alert("Failed to upload dataset.");
      return;
    }

    var data = JSON.stringify(mapping);
    var xhr = new XMLHttpRequest();

    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        // console.log(this.responseText);
        var valjson = {};
        try {
          valjson = JSON.parse(this.response);
          if (valjson["body"] === '"Daily limit reached!"') {
            alert("Daily limit reached!");
          } else {
            try {
              oldDate = getConfigDate(
                `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")}/${document.getElementById("pname").value.trim()}_config.json`,
                "Last-Modified",
              );

              var timerfun = setInterval(() => {
                console.log("old date " + oldDate);
                newDate = getConfigDate(
                  `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")}/${document.getElementById("pname").value.trim()}_config.json`,
                  "Last-Modified",
                );

                console.log("new date " + newDate);
                if (newDate > oldDate) {
                  getConfigJson();
                  clearInterval(timerfun);
                  setProgressBar(false);
                  getGraphData();
                }
              }, 20000);
            } catch (e) {
              console.log(e);
            }
          }
        } catch {
          console.log("Error");
        }
      }
    });

    xhr.open(
      "POST",
      "https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/train",
    );
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.send(data);
  };

  async function saveModel() {
    if (document.getElementById("pname").value === "") {
      alert("Please enter project name");
    } else {
      let mapping = {};
      mapping["username"] = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      mapping["project"] = document.getElementById("pname").value.trim();

      if (uploadMode === "link") {
        mapping["datafile"] = document.getElementById("outlined-basic").value;
        // console.log("in if");
      } else {
        mapping["datafile"] =
          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${mapping["username"]}/sample.csv`;
        // console.log("in else");
      }
      if (uploadModeTesting === "link") {
        mapping["testfile"] = document.getElementById(
          "outlined-basic-testing",
        ).value;
        // console.log("in if");
      } else {
        mapping["testfile"] =
          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${mapping["username"]}/sampleTest.csv`;
        // console.log("in else");
      }
      mapping["algorithm"] = $("input[name='mlmodel']:checked").val();
      mapping["algotype"] = document.getElementById("algorithmtype").value;
      mapping["testsize"] = (100 - value) * 0.01;
      mapping["epochs"] = epochs;
      mapping["inputs"] = [];
      mapping["outputs"] = [];
      let temp = document.querySelectorAll('[id^="ip"]');
      temp.forEach((e) => {
        if (document.getElementById(`ip${e.value}`).checked) {
          mapping["inputs"].push(e.value);
        }
      });
      temp = document.querySelectorAll('[id^="op"]');
      temp.forEach((e) => {
        if (document.getElementById(`op${e.value}`).checked) {
          mapping["outputs"].push(e.value);
        }
      });

      // console.log("here is mapping "+ JSON.stringify(mapping));
      // handleProjectNameChange();
      try {
        let tempd = await API.graphql({
          query: createEduvanceAITool,
          variables: {
            input: {
              projectname:
                mapping["username"] + "//Intermediate//" + mapping["project"],
              user: mapping["username"],
              projectType: "Intermediate",
              projectData: JSON.stringify(mapping),
              // extraField1:""
            },
          },
        });
        setModelSaved(true);
        // console.log("temp "+JSON.stringify(tempd));
      } catch {
        let tempd = await API.graphql({
          query: updateEduvanceAITool,
          variables: {
            input: {
              projectname:
                mapping["username"] + "//Intermediate//" + mapping["project"],
              user: mapping["username"],
              projectType: "Intermediate",
              projectData: JSON.stringify(mapping),
              // extraField1:""
            },
          },
        });
        setModelSaved(true);
      }
    }
  }

  return (
    <div>
      <div>
        <img
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
          alt="main-background-img"
        />
      </div>

      {graphData.length > 1 ? (
        <div
          id="corremat"
          style={{
            display: "none",
            position: "absolute",
            zIndex: "12",
            backgroundColor: "rgba(0,0,0,0.3)",
            width: "100vw",
            height: "100vh",
          }}
        >
          <div
            style={{
              position: "relative",
              left: "18vw",
              top: "20vh",
              display: "flex",
              justifyContent: "flex-start",
              width: "60vw",
              height: "60vh",
              borderRadius: "6px",
            }}
          >
            <Button
              style={{ position: "relative", right: "-56vw", top: "1vh" }}
              onClick={() => {
                document.getElementById("corremat").style.display = "none";
              }}
              variant="contained"
              color="secondary"
            >
              X
            </Button>
            <img
              id="heatmap"
              style={{
                width: "72vw",
                height: "66vh",
                border: "6px solid grey",
                borderRadius: "12px",
                boxShadow:
                  "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              }}
              content="no-cache"
              src={`https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname}_heatmap.png`}
              alt="heatmap-img"
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      <Snackbar
        open={modelSaved}
        autoHideDuration={6000}
        message="Project Saved"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        action={
          <React.Fragment>
            <IconButton
              aria-label="close"
              color="inherit"
              onClick={handleModelSavedClose}
            >
              <CloseIcon />
            </IconButton>
          </React.Fragment>
        }
        onClose={handleModelSavedClose}
      ></Snackbar>

      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Grid item>
                  <Link to="/intermediate">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                    >
                      Back
                    </Button>
                  </Link>
                </Grid>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end">
            <Grid container spacing={1}>
              <Grid
                item
                style={{ display: "", position: "relative", zIndex: "4" }}
              >
                <input
                  id="pname"
                  className="myinput"
                  type="text"
                  placeholder="Enter project name"
                />
                &nbsp;&nbsp;&nbsp;
                {/* <Link to={`/test/me}`}> */}
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  onClick={() => {
                    saveModel();
                  }}
                >
                  {" "}
                  Save project
                </Button>
                {/* </Link> */}
                &nbsp;&nbsp;&nbsp;
                {graphData.length > 1 ? (
                  <>
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      onClick={() => {
                        document.getElementById("heatmap").src =
                          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname}_heatmap.png?${Math.floor(Math.random() * 100)}?`;
                        document.getElementById("corremat").style.display =
                          "flex";
                      }}
                    >
                      Correlation matrix
                    </Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      onClick={() => {
                        window.open(
                          `https://eduvancewebai.s3.ap-south-1.amazonaws.com/projects/${Auth.user.username}/${pname}_report.pdf`,
                          "_blank",
                        );
                      }}
                    >
                      Get report
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </div>
          <div className="col-auto align-self-end">
            <Grid
              container
              spacing={1}
              style={{ display: "flex", position: "relative", zIndex: "4" }}
            >
              <Grid item>
                <Link to="/">
                  <Button variant="contained" color="primary" component="span">
                    Home
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <div className="container-fluid text-white mycon">
        <div className="row justify-content-md-center">
          <div className="col-xs-12 col-md-3">
            <div className="card text-center blurback">
              <h3 className="card-header ">Upload Data</h3>
              <div className="card-body">
                <div className="input-group mb-0">
                  <h5
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "12px",
                    }}
                  >
                    Training Dataset
                  </h5>
                  <Grid container justify="flex-start" spacing={1}>
                    <Grid item xs>
                      <TextField
                        id="outlined-basic"
                        style={{ width: "18rem" }}
                        placeholder="Enter Link"
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>

              <div className="card-body">
                <div className="input-group mb-0">
                  <h5
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "12px",
                    }}
                  >
                    Testing Dataset
                  </h5>
                  <Grid container justify="flex-start" spacing={1}>
                    <Grid item xs>
                      <TextField
                        id="outlined-basic-testing"
                        style={{ width: "18rem" }}
                        placeholder="Enter Link"
                      />
                    </Grid>
                  </Grid>
                </div>
              </div>

              <div className="card-body">
                <div className="input-group mb-0">
                  {/* <h5 style={{width:"100%",textAlign:"center",marginBottom:"12px"}}>Testing Dataset</h5> */}
                  <Grid container justify="center" spacing={1}>
                    <Grid item>
                      <Button
                        variant="contained"
                        onClick={handleLinkUpload}
                        color="primary"
                        component="span"
                        startIcon={<CloudUploadIcon />}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>

              <hr style={{ backgroundColor: "white", margin: "0px" }} />

              {columns.length !== 0 ||
              ipColumns.length > 0 ||
              opColumns.length > 0 ? (
                <React.Fragment>
                  <hr
                    style={{
                      backgroundColor: "white",
                      margin: "0px",
                      marginBottom: "15px",
                    }}
                  />
                  <div className="card-body text-left input-card mt-0 ml-2 mr-2">
                    <Grid container spacing={2}>
                      <Grid item>Select Inputs:&nbsp;&nbsp;&nbsp;</Grid>
                      <Grid item xs>
                        {ipColumns.length >= 1 ? (
                          <>
                            {ipColumns.map((element) => (
                              <div>
                                <input
                                  id={`ip${element.name}`}
                                  checked
                                  style={{ transform: "scale(1.5)" }}
                                  type="checkbox"
                                  onClick={() => {
                                    if (
                                      document.getElementById(
                                        "ip" + element.name,
                                      ).checked
                                    ) {
                                      document.getElementById(
                                        "op" + element.name,
                                      ).checked = false;
                                    }
                                  }}
                                  name={element.name}
                                  value={element.name}
                                />
                                <label for="inputs1">
                                  &nbsp; {element.name}{" "}
                                </label>
                              </div>
                            ))}
                          </>
                        ) : (
                          <>
                            {columns.map((element) => (
                              <div>
                                <input
                                  id={`ip${element.name}`}
                                  style={{ transform: "scale(1.5)" }}
                                  type="checkbox"
                                  onClick={() => {
                                    if (
                                      document.getElementById(
                                        "ip" + element.name,
                                      ).checked
                                    ) {
                                      document.getElementById(
                                        "op" + element.name,
                                      ).checked = false;
                                    }
                                  }}
                                  name={element.name}
                                  value={element.name}
                                />
                                <label for="inputs1">
                                  &nbsp; {element.name}{" "}
                                </label>
                              </div>
                            ))}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </div>

                  <div className="card-body text-left input-card m-2">
                    <Grid container spacing={2}>
                      <Grid item>Select Outputs:</Grid>
                      <Grid item xs>
                        {opColumns.length >= 1 ? (
                          <>
                            {opColumns.map((element) => (
                              <div>
                                <input
                                  id={`op${element.name}`}
                                  checked
                                  style={{ transform: "scale(1.5)" }}
                                  type="checkbox"
                                  onClick={() => {
                                    if (
                                      document.getElementById(
                                        "op" + element.name,
                                      ).checked
                                    ) {
                                      document.getElementById(
                                        "ip" + element.name,
                                      ).checked = false;
                                    }
                                  }}
                                  name={element.name}
                                  value={element.name}
                                />
                                <label for="outputs1">
                                  &nbsp; {element.name}{" "}
                                </label>
                              </div>
                            ))}
                          </>
                        ) : (
                          <>
                            {columns.map((element) => (
                              <div>
                                <input
                                  id={`op${element.name}`}
                                  style={{ transform: "scale(1.5)" }}
                                  type="checkbox"
                                  onClick={() => {
                                    if (
                                      document.getElementById(
                                        "op" + element.name,
                                      ).checked
                                    ) {
                                      document.getElementById(
                                        "ip" + element.name,
                                      ).checked = false;
                                    }
                                  }}
                                  name={element.name}
                                  value={element.name}
                                />
                                <label for="outputs1">
                                  &nbsp; {element.name}{" "}
                                </label>
                              </div>
                            ))}
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </React.Fragment>
              ) : zipfile.length > 2 ? (
                <React.Fragment>
                  <div className="card-body text-left m-2 mb-0">
                    <Grid container spacing={2}>
                      <Grid item>Cycles</Grid>
                      <Grid item xs>
                        <Slider
                          min={1}
                          max={20}
                          value={epochs}
                          onChange={handleepochchange}
                          aria-labelledby="continuous-slider"
                          valueLabelDisplay="auto"
                        />
                      </Grid>
                      <Grid item>{epochs}</Grid>
                    </Grid>
                  </div>
                  <div className="card-body text-left m-2 mb-0">
                    <Grid container spacing={2}>
                      <Grid item>Train Test Split</Grid>
                      <Grid item xs>
                        <Slider
                          value={value}
                          onChange={handleChange}
                          aria-labelledby="continuous-slider"
                          valueLabelDisplay="auto"
                        />
                      </Grid>
                      <Grid item>{value}</Grid>
                    </Grid>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
              <hr style={{ backgroundColor: "white", margin: "0px" }} />
              <div className="card-body">
                <div className="input-group mb-0">
                  <h5
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "12px",
                    }}
                  >
                    Select Algorithm Type
                  </h5>
                  <Grid container spacing={1}>
                    <Grid item xs>
                      <select name="algorithmtype" id="algorithmtype">
                        <option value={"classification"}>Classification</option>
                        <option value={"regression"}>Regression</option>
                      </select>
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} style={{ marginTop: "15px" }}>
                    <Grid item xs>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={trainModel}
                      >
                        Build
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-md-4">
            <div
              className="card text-center blurback hiddenradio"
              style={{ marginBottom: "3vh" }}
            >
              <h3 id="training-header" className="card-header ">
                Training Dataset Outputs
              </h3>
              {graphData.length > 1 ? (
                <>
                  {graphData.map((data, index) => (
                    <div
                      className="card-body text-center pt-2 pb-0 "
                      style={{
                        backgroundColor: "white",
                        color: "black",
                        paddingBottom: "18px !important",
                      }}
                    >
                      <h5> {headerValues[index]}</h5>
                      <LineChart
                        width={window.screen.width * 0.27}
                        height={390}
                        data={data}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 60,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        {index < 5 ? (
                          <XAxis
                            label={{
                              value: "Quantity of Data(%)",
                              offset: -15,
                              position: "insideBottom",
                            }}
                            dataKey="name"
                          />
                        ) : (
                          <XAxis
                            label={{
                              value: "Train-Test Split ratio",
                              offset: -15,
                              position: "insideBottom",
                            }}
                            dataKey="name"
                          />
                        )}
                        <YAxis
                          label={{
                            value: "Accuracy",
                            angle: -90,
                            position: "insideLeft",
                          }}
                          domain={[0, 100]}
                        />
                        <Tooltip />
                        <Legend verticalAlign="top" align="right" height={36} />
                        {algoType === "classification" ? (
                          <>
                            <Line
                              type="monotone"
                              dataKey="DTC"
                              stroke="#9442ff"
                              activeDot={{ r: 8 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="RFC"
                              stroke="#8884d8"
                              activeDot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="SVC"
                              stroke="#82ca9d"
                            />
                          </>
                        ) : (
                          <>
                            <Line
                              type="monotone"
                              dataKey="DTR"
                              stroke="#9442ff"
                              activeDot={{ r: 8 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="RFR"
                              stroke="#8884d8"
                              activeDot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="OLS"
                              stroke="#82ca9d"
                            />
                          </>
                        )}
                      </LineChart>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
              {progressBar ? (
                <div className="card-body text-center pt-2 pb-0 ">
                  <h5>Building Machine ....</h5>
                  <img
                    src="/assets/images/build1.gif"
                    alt="build-img"
                    style={{
                      width: "107%",
                      height: "auto",
                      opacity: "0.3",
                      position: "relative",
                      left: "-19px",
                      top: "8px",
                    }}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="col-xs-12 col-md-4">
            <div className="card text-center blurback hiddenradio">
              <h3 className="card-header ">Realworld Dataset Outputs</h3>

              {testingGraphData.length > 1 ? (
                <>
                  {testingGraphData.map((data, index) => (
                    <div
                      className="card-body text-center pt-2 pb-0 "
                      style={{ backgroundColor: "white", color: "black" }}
                    >
                      <h5> {headerValues[index]}</h5>
                      <LineChart
                        width={window.screen.width * 0.27}
                        height={390}
                        data={data}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 60,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        {index < 5 ? (
                          <XAxis
                            label={{
                              value: "Quantity of Data(%)",
                              offset: -15,
                              position: "insideBottom",
                            }}
                            dataKey="name"
                          />
                        ) : (
                          <XAxis
                            label={{
                              value: "Train-Test Split ratio",
                              offset: -15,
                              position: "insideBottom",
                            }}
                            dataKey="name"
                          />
                        )}
                        <YAxis
                          label={{
                            value: "Accuracy",
                            angle: -90,
                            position: "insideLeft",
                          }}
                          domain={[0, 100]}
                        />
                        <Tooltip />
                        <Legend verticalAlign="top" align="right" height={36} />
                        {algoType === "classification" ? (
                          <>
                            <Line
                              type="monotone"
                              dataKey="DTC"
                              stroke="#9442ff"
                              activeDot={{ r: 8 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="RFC"
                              stroke="#8884d8"
                              activeDot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="SVC"
                              stroke="#82ca9d"
                            />
                          </>
                        ) : (
                          <>
                            <Line
                              type="monotone"
                              dataKey="DTR"
                              stroke="#9442ff"
                              activeDot={{ r: 8 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="RFR"
                              stroke="#8884d8"
                              activeDot={{ r: 4 }}
                            />
                            <Line
                              type="monotone"
                              dataKey="OLS"
                              stroke="#82ca9d"
                            />
                          </>
                        )}
                      </LineChart>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiConfigProject;
